import { render, staticRenderFns } from "./furnitureshop-carousel.vue?vue&type=template&id=6d4fd5e7&scoped=true&"
import script from "./furnitureshop-carousel.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-carousel.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-carousel.vue?vue&type=style&index=0&id=6d4fd5e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4fd5e7",
  null
  
)

export default component.exports